// src/router/index.js 
import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../store/auth';
import { toast } from 'vue-toastification';

// Impor Layout
import MainLayout from '../layouts/MainLayout.vue';

// Impor Halaman
import LoginPage from '../views/LoginPage.vue';
import DashboardPage from '../views/DashboardPage.vue';
import AccountDetailPage from '../views/AccountDetailPage.vue';
import CsPage from '../views/CsPage.vue';
import ProfilePage from '../views/ProfilePage.vue';
import RegisterPage from '../views/RegisterPage.vue';
import SupervisorPage from '../views/SupervisorPage.vue';
import TellerPage from '../views/TellerPage.vue';
import MarketingPage from '../views/MarketingPage.vue';
import LedgerPage from '../views/LedgerPage.vue';
import TransactionCodeManagement from '../views/TransactionCodeManagement.vue';
import UserManagementPage from '../views/UserManagementPage.vue';
import LoanReviewPage from '../views/LoanReviewPage.vue';


const routes = [
  // Rute untuk halaman yang tidak menggunakan layout utama (seperti Login)
  { path: '/login', name: 'Login', component: LoginPage },
  { path: '/register', name: 'Register', component: RegisterPage },
  
  // Rute yang menggunakan MainLayout
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/dashboard' }, // Redirect dari '/' ke '/dashboard'
      { path: 'dashboard', name: 'Dashboard', component: DashboardPage },
      { path: 'profile', name: 'Profile', component: ProfilePage },
      { path: 'account/:id', name: 'AccountDetail', component: AccountDetailPage, props: true },
      { 
        path: 'supervisor-tools', 
        name: 'SupervisorTools', 
        component: SupervisorPage, 
        meta: { roles: ['supervisor', 'superadmin'] }
      },
      { 
        path: 'teller-tools', 
        name: 'TellerTools', 
        component: TellerPage, 
        meta: { roles: ['teller', 'superadmin'] }
      },
      { 
        path: 'marketing-tools', 
        name: 'MarketingTools', 
        component: MarketingPage, 
        meta: { roles: ['marketing', 'superadmin'] }
      },
       { 
        path: 'ledger', 
        name: 'Ledger', 
        component: LedgerPage, 
        meta: { roles: ['superadmin'] }
      },
      { 
        path: 'master-data/transaction-codes', 
        name: 'TransactionCodeManagement', 
        component: TransactionCodeManagement, 
        meta: { roles: ['supervisor', 'superadmin'] }
      },
      { 
        path: 'cs-tools', 
        name: 'CsTools', 
        component: CsPage, 
        meta: { roles: ['cs', 'superadmin'] }
      }, 
      { 
        path: 'loans/:id/review', 
        name: 'LoanReview', 
        component: LoanReviewPage, 
        props: true,
        meta: { roles: ['marketing', 'supervisor', 'superadmin'] }
      },
      {
        path: 'admin/all-users',
        name: 'UserManagement',
        component: UserManagementPage,
        meta: { roles: ['superadmin'] }
      }
      // Tambahkan rute anak lainnya di sini (mis: '/profile')
    ]
  },
  // Tangkap semua path yang tidak cocok dan arahkan ke login
  { path: '/:pathMatch(.*)*', redirect: '/login' }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation Guard sekarang lebih sederhana
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  
  // Pastikan state (termasuk token & peran) selalu dimuat sebelum setiap navigasi
  authStore.loadStateFromStorage(); 

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiredRoles = to.matched.flatMap(record => record.meta.roles || []);

  if (requiresAuth && !authStore.isAuthenticated) {
    next('/login');
  } else if (requiredRoles.length > 0 && !requiredRoles.includes(authStore.userRole)) {
    toast.error('Anda tidak memiliki hak akses ke halaman ini.');
    next('/dashboard');
  } else {
    next();
  }
});


export default router;